export default __webpack_public_path__ + "static/media/year11.135da1bd.svg";